import { render, staticRenderFns } from "./zyjgtforderment.vue?vue&type=template&id=4e144b14&scoped=true"
import script from "./zyjgtforderment.vue?vue&type=script&lang=js"
export * from "./zyjgtforderment.vue?vue&type=script&lang=js"
import style0 from "./zyjgtforderment.vue?vue&type=style&index=0&id=4e144b14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e144b14",
  null
  
)

export default component.exports